import { matchesNestedKeyword } from '../../shared/utils/keyword-filter';
import { JstDate, serverTime } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { MemberService } from '../../core/services/member.service';
import { StudioService } from '../../core/services/studio.service';
import { TransactionService } from '../../core/services/transaction.service';
import { InvoiceService } from '../../core/services/invoice.service';
import { PagerComponent } from '../../shared/components/pager.component';
import { TransactionNewComponent } from './transaction-new.component';
import { TransactionEditComponent } from './transaction-edit.component';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { prepareReceiptTextForCapture } from '../../shared/utils/receipt-capture';

const CHARGE_TYPE_NAMES: { [key: number]: string } = {
  0: 'その他', 1: '月会費', 2: '入会金・事務手数料', 3: 'ロッカー費', 4: 'PT費', 5: '物販',
};

const STATUS_OPTIONS = [
  { id: 0, name: '請求予定' }, { id: 1, name: '削除済' }, { id: 2, name: '請求確定' },
  { id: 5, name: '入金済' }, { id: 6, name: '入金エラー' }, { id: 7, name: '払い戻し済' },
  { id: 8, name: '請求停止' }, { id: 9, name: '受け取り' },
];

@Component({
    selector: 'app-transaction-member',
    imports: [FormsModule, DecimalPipe, PagerComponent, TransactionNewComponent, TransactionEditComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ filteredItems.length }} 件)</span></span>
        </div>
        <div class="card-body">
          <form novalidate name="myListForm">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">店舗</label>
                  <label class="col-md-8 col-form-label">{{ member?.studio?.name }}</label>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">会員ID・氏名</label>
                  <label class="col-md-8 col-form-label">
                    {{ member?.memberCode }}&nbsp;
                    {{ member?.lastName }}&nbsp;{{ member?.firstName }}&nbsp;
                    &#040;{{ member?.lastNameKana }}&nbsp;{{ member?.firstNameKana }}&#041;
                  </label>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">会員住所</label>
                  <label class="col-md-8 col-form-label">
                    〒{{ member?.zip }}&nbsp;{{ member?.province }}&nbsp;{{ member?.city }}&nbsp;{{ member?.area }}&nbsp;{{ member?.address }}
                  </label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">コース区分</label>
                  <label class="col-md-8 col-form-label">{{ member?.studioPlan?.name }}</label>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">会員TEL</label>
                  <label class="col-md-8 col-form-label">{{ member?.phone }}</label>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">会員メール</label>
                  <label class="col-md-8 col-form-label">{{ member?.email }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="col-form-label" for="status">状態</label>
                  <select class="form-control" id="status" name="status" [(ngModel)]="statusFilter">
                    <option [ngValue]="null">-- すべて --</option>
                    @for (so of statusOptions; track so.id) {
                      <option [ngValue]="so">{{ so.name }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-md-8">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label class="col-form-label" for="keyword">キーワード検索</label>
                    <input id="keyword" name="keyword" type="text" [(ngModel)]="keyword"
                      class="form-control" placeholder="明細に含まれる文字列など"
                      (ngModelChange)="pageIndex = 0">
                  </div>
                </div>
              </div>
              <div class="col-md-4 d-flex align-items-end">
                <div class="form-group row">
                  <div class="col-md-12">
                    <button class="btn btn-warning text-white" type="button" (click)="clearFilter()">
                      <i class="fa s-icon-backspace"></i>&nbsp;条件クリア
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="card-body">
          <div class="form-group row">
            <div class="col-md-12">
              <button class="btn btn-primary text-white" type="button" (click)="showNewTransactionModal = true">
                <i class="fa s-icon-plus"></i>&nbsp;新規作成
              </button>
            </div>
          </div>
          <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
          @if (!searching && filteredItems.length === 0) {
            <span>該当するデータはありません</span>
          }
          @if (searching) {
            <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
          }
          @if (filteredItems.length > 0) {
            <div class="table-responsive parity-table-scroll">
<table class="parity-wide-table table table-bordered table-sm table-hover table-ptb-0">
              <thead>
                <tr>
                  <th style="width: 3%;"></th>
                  <th style="width: 10%;">状態</th>
                  <th>売上年月</th>
                  <th>売上タイプ</th>
                  <th>明細</th>
                  <th>金額</th>
                  <th>支払方法</th>
                  <th style="width: 10%;"></th>
                </tr>
              </thead>
              <tbody>
                @for (item of pagedItems; track item.id) {
                  <tr>
                    <td class="text-center text-white"
                      [class.bg-warning]="item.status === 6 && item.invoice != null && item.invoice.retryCount === 0"
                      [class.bg-danger]="item.status === 6 && item.invoice != null && item.invoice.retryCount > 0 && item.invoice.retryCount !== 9 && item.invoice.retryCount !== 99">
                      @if (item.status === 6 && item.invoice != null && item.invoice.retryCount !== 9 && item.invoice.retryCount !== 99) {
                        {{ item.invoice.retryCount + 1 }}
                      }
                    </td>
                    <td>
                      <div class="d-flex flex-column bd-highlight text-center">
                        @if (item.status === 0) { <span class="text-warning"><i class="fa s-icon-schedule fa-2x fa-fw"></i></span> }
                        @if (item.status === 1) { <span class="text-secondary"><i class="fa s-icon-close fa-2x fa-fw"></i></span> }
                        @if (item.status === 2) { <span class="text-warning"><i class="fa s-icon-waiting fa-2x fa-fw"></i></span> }
                        @if (item.status === 3) { <span class="text-primary"><i class="fa fa-gavel fa-2x fa-fw"></i></span> }
                        @if (item.status === 4) { <span class="text-secondary"><i class="fa fa-times-circle fa-2x fa-fw"></i></span> }
                        @if (item.status === 5) {
                          <span [class.text-success]="!item.isOvercharged" [class.text-danger]="item.isOvercharged">
                            <i class="fa s-icon-finished fa-2x fa-fw"></i>
                          </span>
                        }
                        @if (item.status === 6) { <span class="text-danger"><i class="fa s-icon-attention fa-2x fa-fw"></i></span> }
                        @if (item.status === 7) { <span class="text-success"><i class="fa s-icon-back fa-2x fa-fw"></i></span> }
                        @if (item.status === 8) { <span class="text-secondary" title="請求停止"><span class="material-icons-outlined fa-2x fa-fw">do_disturb_on</span></span> }
                        @if (item.status === 9) { <span class="text-success" title="受け取り"><i class="fa s-icon-cashPay fa-2x fa-fw"></i></span> }
                        <div>
                          @if (item.status === 0 || item.status === 6) {
                            <button type="button" class="btn btn-primary text-white btn-sm ml-1 mr-1 mb-1"
                              style="padding-top: 0.1rem !important;padding-bottom: 0.1rem !important;"
                              (click)="setPayInCash(item)" title="受け取り処理">
                              <i class="fa s-icon-settlement fa-fw"></i>
                            </button>
                          }
                          @if (item.status === 0 || item.status === 6) { <br> }
                          @if (item.status === 0 || item.status === 3 || item.status === 6) {
                            <button type="button" class="btn btn-danger text-white btn-sm ml-1 mr-1 mb-1"
                              style="padding-top: 0.1rem !important;padding-bottom: 0.1rem !important;"
                              (click)="setDeleteItem(item)">
                              <i class="fa fa-trash fa-fw"></i>
                            </button>
                          }
                        </div>
                      </div>
                    </td>
                    <td>{{ item.yearPay }}年{{ item.monthPay }}月</td>
                    <td>{{ chargeTypeName(item.chargeType) }}</td>
                    <td>{{ item.title }}</td>
                    <td><span class="pull-right">¥{{ item.amount | number:'1.0-0' }}</span></td>
                    <td>
                      @if (item.paymentMethod === 0) { <span>口座振替</span> }
                      @if (item.paymentMethod === 1) { <span>クレジット</span> }
                    </td>
                    <td class="text-center">
                      @if (item.status === 0 || item.status === 2 || item.status === 5 || item.status === 6 || item.status === 7) {
                        <span class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                          (click)="openEditTransactionModal(item)" title="編集">
                          <i class="fa s-icon-edit fa-fw"></i>
                        </span>
                      }
                      @if (item.status === 5 || item.status === 9) {
                        <button type="button" class="mt-1 mb-1 btn btn-success btn-sm" title="領収書" (click)="openReceiptModal(item)">
                          <i class="fa s-icon-dawnload fa-fw"></i>
                        </button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
</div>
          }
          <app-pager [pageIndex]="pageIndex" [totalPages]="totalPages" (pageChange)="goToPage($event)"></app-pager>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showNewTransactionModal && member) {
  <app-transaction-new [memberId]="memberId" [member]="member"
    (closed)="showNewTransactionModal = false" (saved)="refreshTransactions()"></app-transaction-new>
}

@if (showEditTransactionModal && selectedTransactionId && member) {
  <app-transaction-edit [memberId]="memberId" [transactionId]="selectedTransactionId" [member]="member"
    (closed)="closeEditTransactionModal()" (saved)="refreshTransactions()"></app-transaction-edit>
}

<!-- 受け取り処理モーダル -->
@if (showPayInCashModal && picItem) {
  <div class="modal-backdrop fade show" (click)="showPayInCashModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="payInCashModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content border-danger">
        <div class="modal-header bg-danger">
          <h5 class="modal-title" id="payInCashModalLabel"><i class="fa s-icon-attention"></i> 受け取り処理</h5>
          <button type="button" class="close" (click)="showPayInCashModal = false">
            <span class="text-white" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="background-color: #FFF6F8 !important">
          <div class="form-group row">
            <label class="col-md-12 col-form-label">変更ボタンを押すと状態にかかわらず、<br>関係するすべての請求が「受け取り」となります。</label>
          </div>
          <div class="form-group">
            <table class="table table-sm table-borderless">
              <tr>
                <th class="text-right" style="width: 20%;">会員ID：</th>
                <td>{{ member?.memberCode }}</td>
              </tr>
              <tr>
                <th class="text-right" style="width: 20%;">氏名：</th>
                <td>{{ member?.lastName }}&nbsp;{{ member?.firstName }}</td>
              </tr>
              @for (transaction of payInCashTransactions; track transaction.id; let i = $index) {
                <tr>
                  <th class="text-right" style="width: 20%;">{{ i + 1 }}：</th>
                  <td>{{ transaction.title }}&nbsp;¥{{ transaction.amount | number:'1.0-0' }}</td>
                </tr>
              }
            </table>
          </div>
        </div>
        <div class="modal-footer" style="background-color: #FFF6F8 !important">
          <button class="btn bg-close text-white" type="button" (click)="showPayInCashModal = false">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-primary text-white" type="button" (click)="payInCash()">
            <i class="fa s-icon-turnOver"></i>&nbsp;変更
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- 領収書モーダル -->
@if (showReceiptModal && receiptTransaction) {
  <div class="modal-backdrop fade show" (click)="showReceiptModal = false"></div>
  <div class="modal fade show d-block" id="showReceiptModal" tabindex="-1" role="dialog" aria-labelledby="showReceiptModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div id="transactionReceipt">
          <div class="modal-header">
            <h3 class="modal-title font-weight-bold receipt-title" id="showReceiptModalLabel">領収書</h3>
          </div>
          <div class="modal-body">
            <div class="col-md-12 clearfix">
              <div class="float-right"><span class="font-weight-bold">No.&nbsp;</span><span>{{ receiptTransaction.id }}</span></div>
            </div>
            <div class="col-md-12 clearfix">
              <div class="float-right">
                <span class="font-weight-bold">発行日&nbsp;</span>
                <input class="receipt-year" [(ngModel)]="receiptInput.year" type="text" maxlength="4"><span>年</span>
                <input class="receipt-month" [(ngModel)]="receiptInput.month" type="text" maxlength="2"><span>月</span>
                <input class="receipt-day" [(ngModel)]="receiptInput.day" type="text" maxlength="2"><span>日</span>
              </div>
            </div><br />
            <div class="col-md-12 clearfix">
              <input type="text" class="h3 receipt-name" [(ngModel)]="receiptInput.name" maxlength="15" [style.width.em]="receiptNameWidth"><span class="h3">様</span>
            </div><br />
            <div class="col-md-12 bg-light clearfix">
              <p class="h2 text-center font-weight-bold">¥{{ receiptTransaction.amount | number:'1.0-0' }}-</p>
            </div>
            <div class="col-md-12 clearfix">
              <div class="text-center">
                <span style="vertical-align: top">但し</span>
                <input class="receipt-proviso" [(ngModel)]="receiptInput.proviso" type="text" maxlength="20">
                <p>代金として上記正に領収いたしました。</p>
              </div>
            </div>
            <div class="row">
              <ul class="col-md-5 ml-md-auto corporate-seal" style="list-style: none;word-wrap: break-word;">
                <li class="font-weight-bold">内訳(税率{{ receiptTaxRate * 100 }}%)</li>
                <li class="font-weight-bold border-top d-flex justify-content-between"><span>税抜金額</span><span>¥{{ receiptTaxExcluded | number:'1.0-0' }}-</span></li>
                <li class="font-weight-bold border-top d-flex justify-content-between"><span>消費税等</span><span>¥{{ receiptTaxAmount | number:'1.0-0' }}-</span></li>
                <li class="font-weight-bold border-top"></li>
              </ul>
              <div class="col-md-7 ml-md-auto corporate-seal">
                @if (studio?.owner?.id != 1) {
                  <span class="font-weight-bold">{{ studio?.owner?.name }}<br/></span>
                  <span class="font-weight-bold">{{ studio?.receiptName || studio?.name }}</span>
                } @else {
                  <span class="font-weight-bold">株式会社スマートフィットネス</span>
                }
                @if (studio?.owner?.invoiceRegistrationNumber) {
                  <span><br/>登録番号T{{ studio?.owner?.invoiceRegistrationNumber }}</span>
                }
                <br/>
                <span>〒&nbsp;{{ member?.studio?.zip }}</span>
                <ul style="list-style: none;padding: 0;word-wrap: break-word;">
                  <li>{{ member?.studio?.province }}@if ((member?.studio?.city?.length || 0) > 15) {<br/>}{{ member?.studio?.city }}@if ((member?.studio?.province?.length || 0) + (member?.studio?.city?.length || 0) + (member?.studio?.area?.length || 0) > 18) {<br/>}{{ member?.studio?.area }}@if ((member?.studio?.area?.length || 0) + (member?.studio?.address?.length || 0) > 18) {<br/>}{{ member?.studio?.address }}</li>
                  <li>TEL:&nbsp;{{ member?.studio?.phone }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showReceiptModal = false"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
          <button class="btn btn-success" type="button" (click)="downloadReceipt()"><i class="fa s-icon-dawnload"></i>&nbsp;ダウンロード</button>
        </div>
      </div>
    </div>
  </div>
}

<!-- 削除確認モーダル -->
@if (showDeleteModal && deleteItem) {
  <div class="modal-backdrop fade show" (click)="showDeleteModal = false"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="deleteTransactionModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content border-danger">
        <div class="modal-header bg-danger">
          <h5 class="modal-title" id="deleteTransactionModalLabel">売上の削除</h5>
          <button type="button" class="close" (click)="showDeleteModal = false">
            <span class="text-white" aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="background-color: #FFF6F8 !important">
          <div class="form-group row">
            <label class="col-md-12 col-form-label">売上を削除します。よろしいですか。</label>
          </div>
        </div>
        <div class="modal-footer" style="background-color: #FFF6F8 !important">
          <button class="btn bg-close text-white" type="button" (click)="showDeleteModal = false">
            <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
          </button>
          <button class="btn btn-danger" type="button" (click)="doDelete()">
            <i class="fa s-icon-delete"></i>&nbsp;削除
          </button>
        </div>
      </div>
    </div>
  </div>
}
  `
})
export class TransactionMemberComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private route = inject(ActivatedRoute);
  private memberService = inject(MemberService);
  private studioService = inject(StudioService);
  private transactionService = inject(TransactionService);
  private invoiceService = inject(InvoiceService);

  memberId!: number;
  member: any = null;
  // 領収書は owner / receiptName / invoiceRegistrationNumber を持つ店舗詳細が要る。
  // /member/:id の member.studio には含まれないため旧版 transaction.js:374 と同じく /studio/:id を別途取得する
  studio: any = null;
  items: any[] = [];
  keyword = '';
  statusFilter: any = null;
  searching = true;

  readonly statusOptions = STATUS_OPTIONS;

  // Pagination
  // 旧版 transaction.js:326 (MemberTransactionMgmtCtl) と同じ100件／ページ
  readonly pageLimit = 100;
  pageIndex = 0;

  // Modals
  showNewTransactionModal = false;
  showEditTransactionModal = false;
  selectedTransactionId: number | null = null;
  showPayInCashModal = false;
  picItem: any = null;
  payInCashTransactions: any[] = [];
  payInCashInvoice: any = null;
  showDeleteModal = false;
  deleteItem: any = null;
  showReceiptModal = false;
  receiptTransaction: any = null;
  receiptInput: any = {};

  chargeTypeName(id: number): string { return CHARGE_TYPE_NAMES[id] ?? String(id); }

  get payInCashTotal(): number {
    return this.payInCashTransactions.reduce((sum, item) => sum + Number(item.amount ?? 0), 0);
  }

  get receiptTaxRate(): number {
    return Number(this.receiptTransaction?.product?.taxRate?.rate ?? 0);
  }

  get receiptTaxAmount(): number {
    return Number(this.receiptTransaction?.taxAmount ?? 0);
  }

  get receiptTaxExcluded(): number {
    return Number(this.receiptTransaction?.amount ?? 0) - this.receiptTaxAmount;
  }

  get receiptNameWidth(): number {
    const name = String(this.receiptInput?.name ?? '');
    if (!name) return 0.5;
    const width = Array.from(name).reduce((currentWidth, char) => {
      return currentWidth + (/^[\x01-\x7E\uFF61-\uFF9F]$/.test(char) ? 0.6 : 1);
    }, 1);
    return Math.min(width, 15.5);
  }

  get filteredItems(): any[] {
    let list = this.items;
    list = list.filter(item => matchesNestedKeyword(item, this.keyword));
    if (this.statusFilter != null) {
      list = list.filter(i => i.status === this.statusFilter.id);
    }
    return list;
  }

  get pagedItems(): any[] {
    return this.filteredItems.slice(this.pageIndex * this.pageLimit, (this.pageIndex + 1) * this.pageLimit);
  }

  get totalPages(): number { return Math.ceil(this.filteredItems.length / this.pageLimit); }
  get pageNumbers(): number[] { return Array.from({ length: this.totalPages }, (_, i) => i); }

  goToPage(p: number): void {
    this.pageIndex = Math.max(0, Math.min(p, this.totalPages - 1));
  }

  clearFilter(): void {
    this.keyword = '';
    this.statusFilter = null;
    this.pageIndex = 0;
  }

  async setPayInCash(item: any): Promise<void> {
    this.picItem = item;
    this.payInCashInvoice = null;
    this.payInCashTransactions = [];
    // 旧版 transaction.js:591-609: modalは請求取得の完了を待たずに開く
    this.showPayInCashModal = true;
    if (item.invoice == null) {
      this.payInCashTransactions = [item];
    } else if (item.status === 0 || item.status === 3 || item.status === 6) {
      const invoice: any = await this.invoiceService.getOne(item.invoice.id);
      if (this.picItem !== item) return;
      this.payInCashInvoice = invoice;
      this.payInCashTransactions = (invoice?.transactions ?? []).filter((t: any) => t.status === 0 || t.status === 3 || t.status === 6);
    }
  }

  openEditTransactionModal(item: any): void {
    this.selectedTransactionId = Number(item?.id) || null;
    this.showEditTransactionModal = this.selectedTransactionId != null;
  }

  closeEditTransactionModal(): void {
    this.showEditTransactionModal = false;
    this.selectedTransactionId = null;
  }

  async refreshTransactions(): Promise<void> {
    this.items = await this.memberService.getTransaction(this.memberId) ?? [];
  }

  async payInCash(): Promise<void> {
    const ids = this.payInCashTransactions.map(item => item.id).filter(Boolean);
    if (ids.length === 0) return;
    this.showPayInCashModal = false;
    await this.transactionService.update({ id: ids, status: 9 });
    if (this.payInCashInvoice?.id) {
      await this.invoiceService.updateStatus({ id: this.payInCashInvoice.id, status: 9 });
    }
    const idSet = new Set(ids);
    this.items = this.items.map(item => idSet.has(item.id) ? { ...item, status: 9 } : item);
    this.picItem = null;
    this.payInCashTransactions = [];
    this.payInCashInvoice = null;
  }

  openReceiptModal(item: any): void {
    this.receiptTransaction = item;
    const date = new JstDate(item.capturedAt ?? item.createdAt ?? serverTime.now());
    this.receiptInput = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      name: `${this.member?.lastName ?? ''} ${this.member?.firstName ?? ''}`.trim(),
      proviso: `「${item.title ?? ''}」`,
    };
    this.showReceiptModal = true;
  }

  async downloadReceipt(): Promise<void> {
    if (!this.receiptTransaction) return;
    const elm = document.getElementById('transactionReceipt');
    if (!elm) return;
    const canvas = await html2canvas(elm, {
      backgroundColor: '#FFFFFF',
      width: 500,
      height: 800,
      scrollX: 0,
      scrollY: 0,
      onclone: prepareReceiptTextForCapture,
    });
    const pdf = new jsPDF('p', 'pt', 'a4', false);
    const width = pdf.internal.pageSize.getWidth();
    pdf.addImage(canvas, 'PNG', 0, 0, width, 0);
    const fileName = `${String(this.member?.memberCode ?? '').replace('-', '')}${this.receiptTransaction.id}.pdf`;
    pdf.save(fileName);
    this.showReceiptModal = false;
  }

  setDeleteItem(item: any): void {
    this.deleteItem = item;
    this.showDeleteModal = true;
  }

  async doDelete(): Promise<void> {
    if (!this.deleteItem?.id) return;
    const id = this.deleteItem.id;
    const invoiceId = this.deleteItem?.invoice?.id;
    this.showDeleteModal = false;
    await this.transactionService.remove(id);
    if (invoiceId) {
      await this.invoiceService.updateAmount({ id: invoiceId });
    }
    this.items = this.items.filter(item => item.id !== id);
    this.deleteItem = null;
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員別売上', 's-icon-plans');
    this.memberId = +this.route.snapshot.params['memberId'];
    try {
      [this.member, this.items] = await Promise.all([
        this.memberService.getOne(this.memberId),
        this.memberService.getTransaction(this.memberId),
      ]);
      this.items = this.items ?? [];
      const studioId = this.member?.studio?.id;
      if (studioId) this.studio = await this.studioService.list(studioId) ?? null;
    } finally {
      this.searching = false;
    }
  }
}
